module.exports = __webpack_public_path__ + "static/media/609.18f9d16b.png";